import { Component, ElementRef, forwardRef, HostListener, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { MASKS } from 'ng-brazil';

@Component({
  selector: 'app-custom-ngb-timepicker',
  templateUrl: './custom-ngb-timepicker.component.html',
  styleUrls: ['./custom-ngb-timepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomNgbTimepickerComponent),
      multi: true
    }
  ]
})
export class CustomNgbTimepickerComponent implements OnInit, ControlValueAccessor {

  @Input() label = '';
  @Input() placeholder = 'Selecione o horário';
  @Input() required = false;
  @Input() opcional = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() cleareable = false;

  timeValue: NgbTimeStruct | null = null;
  isOpen = false;
  wasInputFocused = false;
  public MASKS = MASKS;

  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef) {}

  ngOnInit() {}

  get displayValue(): string {
    if (!this.timeValue) return '';
    const h = String(this.timeValue.hour).padStart(2, '0');
    const m = String(this.timeValue.minute).padStart(2, '0');
    return `${h}:${m}`;
  }

  togglePicker(): void {
    if (this.disabled || this.readonly) return;
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.wasInputFocused = true;
      this.onTouched();
    }
  }

  onTimeChange(time: NgbTimeStruct): void {
    this.timeValue = time;
    this.onChange(this.displayValue || null);
  }

  onInputChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    const match = /^([0-9]{2}):([0-9]{2})$/.exec(value);
    if (!match) return;
    const hour = Math.min(Number(match[1]), 23);
    const minute = Math.min(Number(match[2]), 59);
    this.timeValue = { hour, minute, second: 0 };
    this.onChange(this.displayValue);
  }

  onInputBlur(): void {
    this.onTouched();
  }

  clearTime(): void {
    this.timeValue = null;
    this.onChange(null);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  writeValue(value: string | null): void {
    if (!value) {
      this.timeValue = null;
      return;
    }
    const timeStr = value.includes('T') ? value.split('T')[1]?.slice(0, 5) : value;
    if (timeStr) {
      const [hour, minute] = timeStr.split(':').map(Number);
      this.timeValue = { hour, minute, second: 0 };
    }
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
